import { createFileRoute, redirect } from '@tanstack/react-router';
import { AppShell } from '@/features/shell/app-shell';
import { hierarchyQuery, keys, meQuery, membersQuery } from '@/lib/queries';

export const Route = createFileRoute('/w/$workspaceId')({
  // `?task=tsk_x` opens that task in the side panel on top of whatever page is showing.
  validateSearch: (search: Record<string, unknown>): { task?: string } =>
    typeof search.task === 'string' ? { task: search.task } : {},
  beforeLoad: async ({ context, params, location }) => {
    const qc = context.queryClient;
    let me = await qc.ensureQueryData(meQuery);
    if (!me) throw redirect({ to: '/login', search: { redirect: location.href } });
    if (!me.workspaces.some((w) => w.id === params.workspaceId)) {
      // The cached list may be stale (just joined or created a workspace).
      await qc.invalidateQueries({ queryKey: keys.me });
      me = await qc.fetchQuery(meQuery);
      if (!me) throw redirect({ to: '/login', search: { redirect: location.href } });
      if (!me.workspaces.some((w) => w.id === params.workspaceId)) throw redirect({ to: '/' });
    }
  },
  loader: ({ context, params }) => {
    // Warm the queries every page needs; do not block navigation on them.
    void context.queryClient.prefetchQuery(hierarchyQuery(params.workspaceId));
    void context.queryClient.prefetchQuery(membersQuery(params.workspaceId));
  },
  component: AppShell,
});
